import { Card } from '@repo/shadcn';

import { SectionContainer } from '@components/shared';
import {
    HeaderBreadcrumb,
    SectionDataTable,
    SectionTitle,
} from '@components/ui';

import { Route } from '@/constants';
import { StockListFilters } from '@/modules/stocks/shared';

import { lowStockListColumns } from './low-stock-list.column';
import { useLowStockList } from './low-stock-list.hook';

export const LowStockList = () => {
    const { isError, error, data, isLoading, isFetching } = useLowStockList();
    return (
        <SectionContainer
            isLoading={isLoading}
            isError={isError}
            error={error}
            fallbackPath={Route.DASHBOARD}
        >
            <Card className={'space-y-4 p-4'}>
                <div className={'flex justify-between'}>
                    <div className={'space-y-4'}>
                        <HeaderBreadcrumb
                            items={[
                                {
                                    label: 'Stocks',
                                    href: Route.STOCK_ALL_PRODUCTS,
                                },
                                { label: 'Low Stock' },
                            ]}
                        />

                        <SectionTitle>Low Stock Products</SectionTitle>
                    </div>
                </div>

                <StockListFilters searchPlaceholder={'low stocks'} />

                <SectionDataTable
                    columns={lowStockListColumns}
                    data={data}
                    isLoading={isLoading || isFetching}
                />
            </Card>
        </SectionContainer>
    );
};

LowStockList.displayName = 'LowStockList';
